module.exports = __webpack_public_path__ + "img/use_phone.36b9545a.png";